import moment from 'moment'
import { InputAutoCompleteIndexedDB } from './indexedDB'
import { historyKeywordsStore } from './config'
import { isValidIndex } from './utils'

export class AutoCompleteStore {
  constructor() {
    this.HISTORY_KEYWORDS_DB = this.initHistoryKeywordsDB()
    this.historyKeywordsMap = {}
    // 最大保存数据个数
    this.autocompleteMaxlength = 20
  }

  /**
  * 创建IndexDB服务
  * @return {db}
  */
  initHistoryKeywordsDB() {
    return new InputAutoCompleteIndexedDB({
      dbname: 'KY_ERP_DB',
      version: '1',
      keyPath: 'inputId',
      stores: [
        {
          storename: historyKeywordsStore,
          keys: { name: 'inputId', unique: false }
        }
      ],
      open: () => {
        // this.initHistoryKeywordsMap()
      }
    })
  }

  /**
  * 初始化历史输入关键池
  * @param
  * @return { Array<object> }
  */
  initHistoryKeywordsMap() {
    this.HISTORY_KEYWORDS_DB.getAll({
      storeName: 'historyKeywordsStore',
    }).then(res => {
      res.forEach(item => {
        const { inputId, historyKeywords = [] } = item
        if (inputId) {
          this.historyKeywordsMap[inputId] = {
            inputId,
            historyKeywords
          }
        }
      })
    })
  }

  /**
  * 更新DB
  * @param {}
  * @return
  */
  updateHistoryKeywordsDB(inputId, keywordsInfo) {
    this.HISTORY_KEYWORDS_DB.update({
      storeName: historyKeywordsStore,
      value: inputId,
      data: keywordsInfo,
    }).catch(e => {
      console.error('updateHistoryKeywords', e)
    })
  }

  /**
  * 更新搜索池
  * @param {inputId:输入框ID, data: 搜索数据值, historyKeywordsMap: 历史搜索池}
  * @return
  */
  updateHistoryKeywords(inputId, data, config) {
    if (!data) return
    const { maxLength } = config
    const keywordsInfo = this.historyKeywordsMap[inputId] || {
      historyKeywords: [],
      inputId
    }
    const { historyKeywords } = keywordsInfo
    const delIndex = historyKeywords.findIndex(item => item.value === data)
    // 当只有一个数组且已存在，不需要热更新位置
    if (delIndex === 0) return
    const _maxLength = maxLength || this.autocompleteMaxlength
    // 热更新位置，先删除后
    if (delIndex !== -1) {
      keywordsInfo.historyKeywords.splice(delIndex, 1)
    }
    const historyKeywordsLength = keywordsInfo.historyKeywords.unshift({ value: data })
    const isDelete = historyKeywordsLength > _maxLength
    if (isDelete) {
      console.log('准备删除')
      keywordsInfo.historyKeywords.pop()
    }
    // 更新 IndexedDB
    console.log('准备更新DB')
    keywordsInfo.updateDate = moment().format('YYYY-MM-DD HH:mm:ss')

    // 用于测试，批量添加数据到indexDB
    // Array(10000).fill(1).forEach((_, index) => {
    //   const _inputId = inputId + index
    //   keywordsInfo.inputId = _inputId
    //   const _keywordsInfo = JSON.parse(JSON.stringify(keywordsInfo))
    //   // eslint-disable-next-line standard/object-curly-even-spacing
    //   _keywordsInfo.historyKeywords = Array(20).fill(1).map((_, index) => ({ value: '测试内容' + index}))
    //   this.updateHistoryKeywordsDB(_inputId, _keywordsInfo)
    // })
    this.updateHistoryKeywordsDB(inputId, keywordsInfo)
    this.historyKeywordsMap[inputId] = keywordsInfo
  }

  /**
  * 更新位置
  * @param
  * @return
  */
  updateHistoryKeywordsIndex(inputId, index) {
    const keywordsInfo = this.historyKeywordsMap[inputId]
    const historyKeywords = keywordsInfo.historyKeywords
    if (historyKeywords && isValidIndex(index, historyKeywords)) {
      const elementToMove = historyKeywords[index]
      historyKeywords.splice(index, 1)
      historyKeywords.unshift(elementToMove)
      this.updateHistoryKeywordsDB(inputId, keywordsInfo)
    }
  }

  /**
  * 删除某个input的数据
  * @param
  * @return
  */
  deleteHistoryKeyword(inputId, data) {
    const keywordsInfo = this.historyKeywordsMap[inputId] || {
      historyKeywords: [],
      inputId
    }
    const index = keywordsInfo.historyKeywords.findIndex((item) => item.value === data.value)
    if (index > -1) {
      keywordsInfo.historyKeywords.splice(index, 1)
      this.updateHistoryKeywordsDB(inputId, keywordsInfo)
    }
  }

  deleteAllHistoryKeyword(inputId) {
    const keywordsInfo = {
      historyKeywords: [],
      inputId
    }
    this.updateHistoryKeywordsDB(inputId, keywordsInfo)
  }

  /**
  * 获取当前输入框的历史搜索信息
  * @param { inputId:输入框ID}
  * @return {[{ inputId: String, historyKeywords: Array }]}
  */
  async getHistoryKeywords(inputId) {
    const keywordsInfo = await this.HISTORY_KEYWORDS_DB.get({
      storeName: 'historyKeywordsStore',
      value: inputId
    })
    if (!keywordsInfo) {
      return {
        inputId,
        historyKeywords: []
      }
    }
    this.historyKeywordsMap = {}
    this.historyKeywordsMap[inputId] = keywordsInfo
    return keywordsInfo

    // 全量查询代码
    // const keywordsInfo = this.historyKeywordsMap[inputId]
    // if (!keywordsInfo) {
      // return {
      //   inputId,
      //   historyKeywords: []
      // }
    // } else {
    //   return keywordsInfo
    // }
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/store.js